/* eslint-disable react-hooks/exhaustive-deps */
// Core
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Styles
import { CommonGlassContainer, H1Head } from "assets/styles/globalStyles";

// Types
import {
    FounderWrapper, OtherEvApps
} from "./styles";

// Components
import Button from "components/Button";
import Loader from "components/Loader";
import Footer from "components/Footer";

// Others
import { fetchData } from "utils/fetch";
import { restAPIs } from "utils/restAPIs";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { APP_ID } from "config/constants";


const Founder: React.FC = () => {
    const { currentLang } = useSelector((store: any) => store.commonData);
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const { t } = useTranslation();
    const [pageLoading, setPageLoading] = useState(false);
    const [data, setData] = useState<any>([]);

    const fetchResult = async () => {
        setLoading(true)
        const res = await fetchData(restAPIs.getFounderInfo(currentLang?.id));
        setData(res.founder);
        setLoading(false)
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchResult();
    }, [currentLang]);


    if (pageLoading) return <Loader />;

    return (
        <>
            <FounderWrapper>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-11">
                            <H1Head style={{ color: '#fff', marginBottom: '20px' }}>{t('founder')}</H1Head>
                            <CommonGlassContainer className="___comn_txt">
                                <div className='row justify-content-end'>
                                    <div className='col-md-3 mb-3'>
                                        <img src={data && data[0]?.logo} width={'100%'} height={'200px'} style={{ objectFit: 'contain' }} />
                                    </div>
                                    {data && data?.map((item: any, idx: React.Key | null | undefined) => {
                                        return (
                                            <div className='col-md-9 mb-3' key={idx}>
                                                <h1 className='__common-head' style={{ fontSize: '1.4rem' }}>{item?.name}</h1>
                                                <p dangerouslySetInnerHTML={{ __html: item?.description }} style={{ lineHeight: 1.7 }}></p>
                                            </div>
                                        )
                                    })}
                                </div>
                            </CommonGlassContainer>
                        </div>
                    </div>
                </div>

                <Footer />

            </FounderWrapper>
        </>
    );
};

export default Founder;

